import * as angular from "angular";

let UpgradePendingComponent = {
    selector: "vcUpgradePending",
    templateUrl:
        "/angular/components/campaign-plan/upgrade-pending.component.html",
    bindings: {
        upgrade: "=",
    },
    controller: class UpgradePendingController {
        // * bindings for typescript compiler *
        public upgrade?: any;
        // ************************************

        private $cookies: any;
        public currency: string;
        public warningBannerDismissed: boolean | undefined = undefined;

        constructor($cookies: any) {
            this.$cookies = $cookies;
            this.warningBannerDismissed =
                $cookies.get("warningBannerDismissed") || false;
        }
        $onChanges() {
            let upgrade = this.upgrade;
            if (!upgrade || !upgrade.plan) {
                return;
            }
            if (upgrade.plan.cpcountry == "EU") {
                this.currency = "€";
            } else if (upgrade.plan.cpcountry == "UK") {
                this.currency = "£";
            } else if (
                upgrade.plan.cpcountry == "USA" ||
                upgrade.plan.cpcountry == "US"
            ) {
                this.currency = "$";
            } else {
                this.currency = "$";
            }
        }
        dismissBanner(): void {
            let expire = new Date();
            expire.setTime(expire.getTime() + 12 * 60 * 60 * 1000);
            this.warningBannerDismissed = true;
            this.$cookies.put("warningBannerDismissed", 1, {
                expires: expire,
            });
        }
    },
};

angular
    .module("campaignplan")
    .component(UpgradePendingComponent.selector, UpgradePendingComponent);
